import { Shield, Clock, Users, Award, MapPin, Headphones } from "lucide-react"

const reasons = [
  {
    icon: Shield,
    title: "Safety First",
    description: "Rigorous safety protocols and fully certified crews on every project.",
  },
  {
    icon: Clock,
    title: "On-Time Delivery",
    description: "Committed to meeting deadlines without compromising quality.",
  },
  {
    icon: Users,
    title: "Expert Teams",
    description: "Multi-domain specialists with years of industry experience.",
  },
  {
    icon: Award,
    title: "Quality Guaranteed",
    description: "Industry-leading standards with comprehensive documentation.",
  },
  {
    icon: MapPin,
    title: "Local Knowledge",
    description: "Great understanding of Michigan terrain and regulations.",
  },
  {
    icon: Headphones,
    title: "24/7 Support",
    description: "Always available to address your project needs.",
  },
]

export function WhyUsSection() {
  return (
    <section className="border-t border-border/40 bg-background py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          {/* Left Content */}
          <div>
            <h2 className="mb-4 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
              Why Choose{" "}
              <span className="text-primary">World Connections</span>?
            </h2>
            <p className="mb-8 text-lg text-muted-foreground">
              Born in 2024 in Ann Arbor, Michigan, we&apos;ve rapidly grown from a startup into a multi-team, multi-domain infrastructure company. Our success is built on delivering exceptional results, every time.
            </p>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-4">
              <div className="rounded-lg border border-border/50 bg-card p-4 text-center">
                <div className="text-3xl font-bold text-primary">100+</div>
                <div className="text-sm text-muted-foreground">Projects</div>
              </div>
              <div className="rounded-lg border border-border/50 bg-card p-4 text-center">
                <div className="text-3xl font-bold text-accent">50+</div>
                <div className="text-sm text-muted-foreground">Clients</div>
              </div>
              <div className="rounded-lg border border-border/50 bg-card p-4 text-center">
                <div className="text-3xl font-bold text-primary">5</div>
                <div className="text-sm text-muted-foreground">Teams</div>
              </div>
            </div>
          </div>
          
          {/* Right - Reasons Grid */}
          <div className="grid gap-4 sm:grid-cols-2">
            {reasons.map((reason, index) => {
              const IconComponent = reason.icon
              const isEven = index % 2 === 0
              
              return (
                <div
                  key={reason.title}
                  className="flex items-start gap-4 rounded-lg border border-border/50 bg-card p-4 transition-all hover:border-primary/30"
                >
                  <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${isEven ? "bg-primary/10" : "bg-accent/10"}`}>
                    <IconComponent className={`h-5 w-5 ${isEven ? "text-primary" : "text-accent"}`} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground">{reason.title}</h3>
                    <p className="text-sm text-muted-foreground">{reason.description}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
